import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { isEqual } from "lodash";
import PropTypes from "prop-types";
import { TemplateDiscussionAndNoteBody } from "~/pages/ProjectTemplates/DiscussionsAndNotes/TemplateDiscussionAndNoteBody";
import { TemplateDiscussionAndNotePanel } from "~/pages/ProjectTemplates/DiscussionsAndNotes/TemplateDiscussionAndNotePanel";
import { TemplateObject } from "~/pages/ProjectTemplates/TemplateObject";
import {
  editProjectTemplateElement,
  fetchProjectTemplateElement,
} from "~/store/actions/actions.projectTemplateElements";

export const TemplateDiscussionAndNote = ({ element }) => {
  const dispatch = useDispatch();

  const templateId = element?.template_id;
  useEffect(() => {
    dispatch(fetchProjectTemplateElement(templateId, element.id));
  }, [dispatch, element.id, templateId]);

  const handleChange = useCallback(
    (newData) => {
      const updatedElement = { ...element, ...newData };
      if (!isEqual(element, updatedElement)) {
        dispatch(editProjectTemplateElement(element.id, templateId, updatedElement));
      }
    },
    [dispatch, element, templateId]
  );

  return (
    <TemplateObject>
      <TemplateDiscussionAndNoteBody element={element} />
      <TemplateDiscussionAndNotePanel
        element={element}
        onChange={handleChange}
      />
    </TemplateObject>
  );
};

TemplateDiscussionAndNote.propTypes = {
  element: PropTypes.object.isRequired,
};
